import Bus from "./src/utils/bus";
let BUS = new Bus();

exports.onRouteUpdate = ({ location }) => {
  BUS.trigger("ON_ROUTE_UPDATE", location.pathname);
};


// WEBPACK FOOTER //
// ./gatsby-browser.js